import '@sophocles/views/sites/components/RelayCards/scheduleListItem.scss';

import { ListItemButton, ListItemText } from '@mui/material';
import React from 'react';

function ScheduleListItem({ primaryText, secondaryText, disabled, onClick }) {
  return (
    <div className="schedule-container">
      <ListItemButton
        disabled={disabled}
        onClick={onClick}
        className="schedule-list-item"
        sx={{ py: { xs: 1, sm: 0.5 }, px: 2 }}
      >
        <ListItemText primary={primaryText} secondary={secondaryText} sx={{ my: 0 }} />
      </ListItemButton>
    </div>
  );
}

export default ScheduleListItem;
